import {
    InsertDriveFile as FileIcon,
    PictureAsPdf as PdfIcon,
    Description as WordIcon,
    TableChart as ExcelIcon,
    Image as ImageIcon,
    Movie as VideoIcon,
    Archive as ArchiveIcon,
    Code as CodeIcon,
    Audiotrack as AudioIcon,
    Slideshow as PowerpointIcon,
    TextSnippet as TextIcon,
    InsertChart as CsvIcon
} from '@mui/icons-material';
import { SvgIconProps } from "@mui/material";
import React from "react";


export function getFileIcon(filename: string): React.ReactElement<SvgIconProps> {
    if (!filename) return <FileIcon />;
    const extension = filename.split(".").pop()?.toLowerCase()
    switch (extension) {
        case 'pdf': return <PdfIcon color="error" />;
        case 'doc':
        case 'docx': return <WordIcon color="primary" />;
        case 'xls':
        case 'xlsx': return <ExcelIcon color="success" />;
        case 'csv': return <CsvIcon color="success" />;
        case 'ppt':
        case 'pptx': return <PowerpointIcon sx={{ color: 'orange' }} />;
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'bmp':
        case 'svg': return <ImageIcon color="secondary" />;
        case 'mp4':
        case 'mov':
        case 'avi':
        case 'mkv': return <VideoIcon sx={{ color: 'darkblue' }} />;
        case 'mp3':
        case 'wav': return <AudioIcon color="action" />;
        case 'zip':
        case 'rar':
        case '7z':
        case 'tar': return <ArchiveIcon sx={{ color: 'brown' }} />;
        case 'html':
        case 'css':
        case 'js':
        case 'ts':
        case 'tsx':
        case 'json': return <CodeIcon color="disabled" />;
        case 'txt':
        case 'md': return <TextIcon />;
        default: return <FileIcon />;
    }
}